import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaPwaApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'pwa';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getServerVersion() {
    return this.http.get(`${this.apiController}/version`, {});
  }
}
